import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface PendingItem {
  doc_no: string;
  vendor_code: string;
  vendor_name: string;
  receiving_doc_no: string;
  return_date: string | null;
  status: string;
  default_checked: boolean;
}

export interface PendingResponse {
  items: PendingItem[];
  total: number;
}

export interface ReverseResultItem {
  doc_no: string;
  success: boolean;
  message: string;
}

export interface ReverseResponse {
  results: ReverseResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface ReversalFilter {
  docStart: string;
  docEnd: string;
}

// ============================================================
// API methods
// ============================================================

export function createR5D6Api(basePath = '/api/r5d6') {
  return {
  // GET /api/r5d6/pending?docStart=&docEnd=
  async getPending(filter: ReversalFilter): Promise<PendingResponse> {
    const res = await apiClient.get(`${basePath}/pending`, {
      params: {
        docStart: filter.docStart,
        docEnd: filter.docEnd,
      },
    });
    return res.data;
  },

  // POST /api/r5d6/reverse
  async reverse(docNos: string[]): Promise<ReverseResponse> {
    // The call is reached only from R5D6Reversal's Popconfirm onConfirm.
    // Keep that UI confirmation bound to the backend A2 confirmation gate.
    const res = await apiClient.post(`${basePath}/reverse`, { doc_nos: docNos, confirmed: true });
    return res.data;
  },
  };
}

export const r5d6Api = createR5D6Api();
export const d5m6Api = createR5D6Api('/api/d5m6');
